export const updateNavColor = (color) => {
  return {
    type: 'UPDATE_NAV_COLOR',
    color,
  }
};